class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    // Move element to body to escape section stacking context
    document.body.appendChild(this);
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    const originalButton = document.querySelector('.pdp-atc button[type="submit"]');
    
    if (!originalButton) {
      return;
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        this.classList.toggle('visible', !entry.isIntersecting);
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0
    });

    this.observer.observe(originalButton);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);